import { useIntl } from "react-intl";
import { WorkflowTask } from "../ReviewsInProgress";
import { ENTER, LEFT, RIGHT } from "@/features/common/constants";

interface EdgeCaseArrowButtonProps {
  direction: string;
  workflowTask: WorkflowTask;
  closeTooltip: () => void;
  clickedStep: number;
  openTooltip: (
    event: any,
    stepIndex: number,
    focusedElement?: HTMLElement,
    edgeCaseTriggered?: boolean,
    direction?: string
  ) => void;
  setClickedStep: (stepIndex: number) => void;
}
export default function EdgeCaseArrowButton({
  direction,
  workflowTask,
  closeTooltip,
  clickedStep,
  openTooltip,
  setClickedStep
}: EdgeCaseArrowButtonProps) {
  function expandRight(
    totalSteps: number,
    stepContainer: HTMLDivElement,
    currentStepIndex: number,
    event: any
  ) {
    if (totalSteps > 0) {
      closeTooltip();
      const nextIndex = (currentStepIndex + 1) % totalSteps;

      const nextElement = stepContainer.children[nextIndex] as HTMLDivElement;
      if (event.key === ENTER) {
        nextElement.tabIndex = 0;
        nextElement.focus();
      }

      setClickedStep(nextIndex);

      setTimeout(() => {
        openTooltip(event, nextIndex, nextElement, undefined, RIGHT);
      }, 100);
    }
  }

  function expandLeft(
    totalSteps: number,
    stepContainer: HTMLDivElement,
    currentStepIndex: number,
    event: any
  ) {
    if (totalSteps > 0) {
      closeTooltip();
      const prevIndex =
        currentStepIndex === -1
          ? totalSteps - 1
          : (currentStepIndex - 1 + totalSteps) % totalSteps;
      const prevElement = stepContainer.children[prevIndex] as HTMLDivElement;
      if (event.key === ENTER) {
        prevElement.tabIndex = 0;
        prevElement.focus();
      }

      setClickedStep(prevIndex);

      setTimeout(() => {
        openTooltip(event, prevIndex, prevElement, undefined, LEFT);
      }, 100);
    }
  }

  function handleArrowButtonClick(event: any, direction: string) {
    if (event.key && event.key !== ENTER) {
      return;
    }
    const steps = workflowTask.steps;
    const totalSteps = steps.length;
    const currentStepIndex = clickedStep;
    let parent = event.target.closest(".task-progress-container");
    const stepContainer = parent.querySelector(".steps-container");
    switch (direction) {
      case RIGHT:
        event.preventDefault();
        expandRight(totalSteps, stepContainer, currentStepIndex, event);
        break;
      case LEFT:
        event.preventDefault();
        expandLeft(totalSteps, stepContainer, currentStepIndex, event);
        break;
      default:
        break;
    }
  }

  const rightArrow = useIntl().formatMessage({
    id: "app.home.reviewsInProgress.rightArrow"
  });
  const leftArrow = useIntl().formatMessage({
    id: "app.home.reviewsInProgress.leftArrow"
  });

  return (
    <>
      <div className={direction === LEFT ? "left-button" : "right-button"}>
        <button
          className="edge-case-button"
          onClick={(event) =>
            handleArrowButtonClick(event, direction === LEFT ? LEFT : RIGHT)
          }
          onKeyDown={(event) =>
            handleArrowButtonClick(event, direction === LEFT ? LEFT : RIGHT)
          }
          aria-label={direction === LEFT ? leftArrow : rightArrow}
        >
          <span
            className={
              direction === LEFT ? "mdi mdi-arrow-left" : "mdi mdi-arrow-right"
            }
          ></span>
        </button>
      </div>
    </>
  );
}
